import { render, staticRenderFns } from "./RawClampColumn.vue?vue&type=template&id=0a995702&scoped=true&"
import script from "./RawClampColumn.vue?vue&type=script&lang=js&"
export * from "./RawClampColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a995702",
  null
  
)

export default component.exports